import { Layout, PaginationType, SideBySideLayout } from '@wix/communities-blog-client-common';
import {
  VideoPlayType,
  CropType,
  ImageRatio,
  ImageAlignment,
  HeightType,
  CategoryLabelType,
  VideoPlaybackSpeed,
  CategoryHeaderLayout,
} from '@app/common/settings-components/types';
import { AlignmentValue } from '@app/common/style-params';

export const LAYOUT_TYPE_AI_DESCRIPTION = `
        The layout type for the blog feed page.
        Possible values:
        - ${Layout.PgSideBySide} Image on one side, content on the other side.
        - ${Layout.PgGrid} Grid layout.
        - ${Layout.PgCardMedium} Tiled layout where each card has it's own size.
        - ${Layout.PgTextOnImageMedium} Magazine layout where text is on the image.
        - ${Layout.PgOneColumn} One column layout.
        `;

export const PAGINATION_TYPE_AI_DESCRIPTION = `
        The pagination type for the blog feed page.
        Possible values:
        - ${PaginationType.InfiniteScroll} Infinite scroll.
        - ${PaginationType.MultiplePages} Multiple pages.
        `;

export const VIDEO_PLAY_TYPE_AI_DESCRIPTION = `
        The video play type for the blog feed page.
        Possible values:
        - ${VideoPlayType.OnHover} On hover.
        - ${VideoPlayType.Autoplay} Autoplay.
        - ${VideoPlayType.OnClick} On click.
        `;

export const LAYOUT_MOBILE_TYPE_AI_DESCRIPTION = `
        The layout type for the blog feed page on mobile.
        Possible values:
        - ${Layout.OneColumnMobile} One column layout.
        - ${Layout.SideBySideMobile} Side by side layout.
        - ${Layout.TextOnImageMobile} Magazine layout where text is on the image.
        `;

export const SIDE_BY_SIDE_LAYOUT_AI_DESCRIPTION = `
        The side by side layout image alignment.
        Possible values:
        - ${SideBySideLayout.ImageLeft} Image on the left.
        - ${SideBySideLayout.ImageRight} Image on the right.
        - ${SideBySideLayout.ImageNone} No image.
        `;

export const ALIGNMENT_VALUE_AI_DESCRIPTION = `
        The text alignment.
        Possible values:
        - ${AlignmentValue.Start} Start alignment.
        - ${AlignmentValue.Center} Center alignment.
        - ${AlignmentValue.End} End alignment.
        `;

export const CROP_TYPE_AI_DESCRIPTION = `
        The image crop type.
        Possible values:
        - ${CropType.Crop} Crop the image to fit.
        - ${CropType.Fit} Fit the image without cropping.
        `;

export const IMAGE_RATIO_AI_DESCRIPTION = `
        The image aspect ratio.
        Possible values:
        - ${ImageRatio.SixteenByNine} 16:9 ratio.
        - ${ImageRatio.FourByThree} 4:3 ratio.
        - ${ImageRatio.OneByOne} 1:1 ratio (square).
        - ${ImageRatio.ThreeByFour} 3:4 ratio.
        - ${ImageRatio.NineBySixteen} 9:16 ratio.
        `;

export const IMAGE_ALIGNMENT_AI_DESCRIPTION = `
        The image alignment.
        Possible values:
        - ${ImageAlignment.End} End alignment.
        - ${ImageAlignment.Start} Start alignment.
        `;

export const HEIGHT_TYPE_AI_DESCRIPTION = `
        The content height type.
        Possible values:
        - ${HeightType.Manual} Manual height.
        - ${HeightType.Auto} Automatic height.
        `;

export const CATEGORY_LABEL_TYPE_AI_DESCRIPTION = `
        The category label type.
        Possible values:
        - ${CategoryLabelType.Text} Text label.
        - ${CategoryLabelType.Button} Button label.
        `;

export const VIDEO_PLAYBACK_SPEED_AI_DESCRIPTION = `
        The video playback speed.
        Possible values:
        - ${VideoPlaybackSpeed.Quarter} 0.25x speed.
        - ${VideoPlaybackSpeed.Half} 0.5x speed.
        - ${VideoPlaybackSpeed.Normal} Normal speed (1x).
        - ${VideoPlaybackSpeed.OneAndQuarter} 1.25x speed.
        - ${VideoPlaybackSpeed.OneAndHalf} 1.5x speed.
        - ${VideoPlaybackSpeed.Two} 2x speed.
        `;

export const CATEGORY_HEADER_LAYOUT_AI_DESCRIPTION = `
        The category header layout.
        Possible values:
        - ${CategoryHeaderLayout.Classic} Stacked image and content.
        - ${CategoryHeaderLayout.Overlay} Content over the cover image.
        - ${CategoryHeaderLayout.SideBySide} Image and content side by side.
        `;
